import { CanvasToolbarButton } from './CanvasToolbarButton';
import { useCanvasFreeElementContext } from '../../../../sweep-canvas/canvas-element-tool/CanvasFreeElementContext';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';
import { Text } from '@sweep-io/sweep-design/dist/icons';
import { useCanvasFreeElementToolbarButtonBehavior } from './useCanvasFreeElementToolbarButtonBehavior';
import { useCallback } from 'react';

export const CanvasTextNodeToolbarButton = ({ isDisabled }: { isDisabled?: boolean }) => {
  const { canvasStickyNotes } = useFeatureToggle();
  const { createTextNodeActive, setCreateElementActive } = useCanvasFreeElementContext();

  const setCreateTextNodeActive = useCallback(
    (active: boolean) => setCreateElementActive(active ? 'text-node' : null),
    [setCreateElementActive],
  );
  const { handleToggle } = useCanvasFreeElementToolbarButtonBehavior({
    createIsActive: createTextNodeActive,
    setCreateIsActive: setCreateTextNodeActive,
    buttonId: 'textNode',
  });

  if (!canvasStickyNotes) {
    return null;
  }

  return (
    <CanvasToolbarButton
      tooltip="New section"
      onToggle={handleToggle}
      pressed={createTextNodeActive}
      disabled={isDisabled}
    >
      <Text />
    </CanvasToolbarButton>
  );
};
